import React from 'react'

import styled from 'styled-components'

import Theme from 'app/theme'
import CsgButton from 'components/atoms/Button'

const RedButton =
  CsgButton &&
  styled(CsgButton)`
    && {
      ${props =>
        props.variant === 'outlined'
          ? `border-color: ${Theme.palette.error.main}; color: ${Theme.palette.error.main};`
          : `background-color: ${Theme.palette.error.main}; color: ${Theme.palette.error.contrastText};`}

      &:hover {
        ${props =>
          props.variant === 'outlined'
            ? `border-color: ${Theme.palette.error.dark}; color: ${Theme.palette.error.dark};`
            : `background-color: ${Theme.palette.error.dark}; color: ${Theme.palette.error.contrastText};`}
      }
    }
  `

const ErrorButton = ({ btnColor, ...props }) => <RedButton {...props} />

export default ErrorButton
